export enum RowFilterKind
{
    All = 'All',
    First = 'First',
    Last = 'Last',
    ByIndex = 'Index',  // example: [42]
    ByRange = 'Range',  // example: [18..45]
    ByFilter = 'Filter', // example: [age < 50]
}
